import { Check } from 'lucide-react'
import './Stepper.css'

/**
 * The progress rail at the head of a multi-step form.
 *
 * Three things it does that a row of numbers does not:
 *
 *   It says where you are, what is behind you and what is ahead, all at once.
 *   The legacy's Bootstrap stepper showed only the current step's number.
 *
 *   A step you have already filled stays REACHABLE. Going back to fix a title
 *   should not mean restarting the flow, and a stepper that only moves forward
 *   turns every typo into a re-entry.
 *
 *   A step you have not reached is not clickable, so the rail cannot be used to
 *   skip validation. `furthest` is how far the form has actually been taken,
 *   which the form owns because only it knows whether a step validated.
 *
 * @param {{id: string, label: string}[]} steps
 * @param {number} current   index being shown
 * @param {number} furthest  highest index reached, so far
 */
export default function Stepper({ steps, current, furthest, onGo }) {
  return (
    <ol className="stepper" data-testid="stepper">
      {steps.map((step, index) => {
        const done = index < furthest
        const here = index === current
        const open = index <= furthest
        return (
          <li
            key={step.id}
            className={`stepper__step${here ? ' is-here' : ''}${done ? ' is-done' : ''}`}
            data-testid="stepper-step"
          >
            <button
              type="button"
              className="stepper__btn"
              onClick={() => open && onGo?.(index)}
              disabled={!open}
              aria-current={here ? 'step' : undefined}
            >
              <span className="stepper__mark">
                {done ? <Check size={14} strokeWidth={3} /> : index + 1}
              </span>
              {/* The label, and nothing under it. A second line of guidance per
                  step put four sentences across the head of a form whose fields
                  say the same thing more precisely — and it was the first thing
                  dropped at every breakpoint, which is the usual sign that a
                  rail was carrying copy that belonged in the form. */}
              <span className="stepper__text">
                <bdi className="stepper__label">{step.label}</bdi>
              </span>
            </button>
          </li>
        )
      })}
    </ol>
  )
}
